import { GridColDef } from "@mui/x-data-grid";
import { CustomActionsCell, CustomNameCell } from "src/components";
import { CustomActionsCellTypes } from "src/components/CustomActionsCell/CustomActionsCell.types";

import { CustomDateCell, CustomStatusCell } from "./components";

export const columns: GridColDef[] = [
  {
    field: "Employee",
    headerName: "Employee",
    width: 240,
    sortable: false,
    renderCell: (params) => <CustomNameCell image={params.row?.master?.photo} value={params.row.master.firstName} />,
  },
  {
    field: "Studio",
    headerName: "Studio",
    width: 270,
    sortable: false,
    valueGetter: (params) => {
      return `${params.row.studio?.title}`;
    },
  },
  {
    field: "Service",
    headerName: "Service",
    width: 240,
    sortable: false,
    valueGetter: (params) => {
      return `${params.row.services?.[0].service?.title}`;
    },
  },
  {
    field: "Date",
    headerName: "Date",
    width: 220,
    sortable: false,
    renderCell: (params) => <CustomDateCell params={params} />,
  },
  {
    field: "Status",
    headerName: "Status",
    minWidth: 260,
    flex: 1,
    sortable: false,
    renderCell: (params) => <CustomStatusCell params={params} />,
  },
  {
    field: "actions",
    headerName: "Actions",
    minWidth: 120,
    sortable: false,
    renderCell: (params) => <CustomActionsCell params={params} type={CustomActionsCellTypes.BOOKINGS} />,
  },
];

export const arrayStatus = [
  {
    id: 1,
    statusValue: "Approved",
    status: "approved",
  },
  {
    id: 2,
    statusValue: "Not paid",
    status: "not_payed",
  },
  {
    id: 3,
    statusValue: "Paid",
    status: "payed",
  },
  {
    id: 4,
    statusValue: "Cancelled by client",
    status: "cancelled",
  },
  {
    id: 5,
    statusValue: "Deleted by admin",
    status: "removed_by_admin",
  },
  {
    id: 6,
    statusValue: "Completed",
    status: "completed",
  },
];
